import React from "react";

const Shimmer = ({ className = "" }) => (
  <div className={`relative overflow-hidden bg-[#1A1A1A] rounded ${className}`}>
    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent" />
  </div>
);

export const SkeletonKpiTile = () => (
  <div className="p-3 rounded bg-[#0F0F0F] border border-[#2A2A2A]">
    <Shimmer className="h-3 w-16 mb-2" />
    <Shimmer className="h-5 w-24" />
  </div>
);

export const SkeletonHero = () => (
  <div className="p-6 rounded-lg" style={{ background: "linear-gradient(135deg, #14141A 0%, #0A0A0F 100%)" }}>
    <Shimmer className="h-4 w-32 mb-4" />
    <Shimmer className="h-10 w-2/3 mb-3" />
    <Shimmer className="h-5 w-1/2" />
  </div>
);

export const SkeletonCard = ({ rows = 5 }) => (
  <div className="p-4 rounded bg-[#0F0F0F] border border-[#2A2A2A] space-y-2">
    <Shimmer className="h-4 w-1/3 mb-3" />
    {Array.from({ length: rows }).map((_, i) => <Shimmer key={i} className="h-4 w-full" />)}
  </div>
);

export default Shimmer;
